import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { NumberFractionQualifierService } from 'src/app/model/api-services/qualifiers/number-fraction-qualifier.service';
import { SL_ID_PREFIX, SlIdContext } from 'src/app/model/directives/sl-id-context';

@Component({
  selector: 'app-number-fraction-input',
  templateUrl: './number-fraction-input.component.html',
  styleUrls: ['./number-fraction-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SlIdContext,
    {
      provide: SL_ID_PREFIX,
      useValue: 'attr-fraction-input'
    }
  ],
})
export class NumberFractionInputComponent extends InputComponent implements OnInit {

  public numericValue = 0;
  public denomLabel = '';
  public minVal = 0;
  public maxVal = Number.MAX_SAFE_INTEGER;

  public set currentValue(val: any) {

    switch (this.attribute.type) {
      case 'text':
      case 'string':
        this.numericValue = NumberFractionQualifierService.FromString(val, this.casting.fractional, false);
        break;
      default:
        this.numericValue = Number(val);
        if (isNaN(this.numericValue)) {
          this.numericValue = Math.max(0, this.minVal);
        }
        break;
    }
  }
  public get currentValue(): any {
    return super.currentValue;
  }

  SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    super.SetAttribute(layer, attribute);
    if (this.attribute.type === 'text') {
      this.numericValue = NumberFractionQualifierService.FromString(this.currentValue, this.casting.fractional, true);
    } else {
      this.numericValue = this.currentValue;
    }
    if (!!this.casting.fractional) {
      this.denomLabel = '<span class="slash-divide mr-2">/</span>' + this.casting.fractional.denom;
    }
    if (!!this.casting.range) {
      this.minVal = this.casting.range.min;
      this.maxVal = this.casting.range.max;
    }
  }
  NumberChanged() {
    if (this.numericValue < this.minVal) {
      this.numericValue = this.minVal;
    }
    if (this.numericValue > this.maxVal) {
      this.numericValue = this.maxVal;
    }
    switch (this.attribute.type) {
      case 'text':
      case 'string':
        this.currentValue = NumberFractionQualifierService.ToString(this.numericValue, this.casting.fractional);
        break;
      default:
        this.currentValue = this.numericValue;
        break;
    }
  }
  Reset() {
    this.minVal = 0;
    this.maxVal = Number.MAX_SAFE_INTEGER;
  }

  constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
    super(cdr);
    super._domNode = this.domNode;
  }

}
